export const TEMPLATE_MODIFY_DENIED_MESSAGE =
	'You can only edit or delete templates you created. Principal users can modify any template.';

/**
 * Principal users may modify any template. Non-principal users may only modify
 * templates they created (matched by ownerDocId against the user's doc id, with
 * createdById fallback).
 */
export const canModifyTemplate = ({ user, template } = {}) => {
	if (user?.principleUser) {
		return true;
	}

	if (!template) {
		return false;
	}

	const templateOwnerDocId = template.ownerDocId;
	const templateCreatedById = template.createdById ?? template.createdBy?.id;

	if (
		user?.userId != null &&
		templateOwnerDocId != null &&
		String(templateOwnerDocId) === String(user.userId)
	) {
		return true;
	}

	if (
		user?.userId != null &&
		templateCreatedById != null &&
		String(templateCreatedById) === String(user.userId)
	) {
		return true;
	}

	return false;
};
